export default "__VITE_ASSET__CTF7Kumf__"